import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, NavController, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class BackButtonService {


  constructor(private platform: Platform,
    private router: Router,
    private navControlelr: NavController, 
    public alertController: AlertController ) { }

  init(){
    this.platform.backButton.subscribeWithPriority(10, async () =>{
      const currentUrl = this.router.url

      if(currentUrl == "/tabs/feed" || currentUrl == "/login"){

        const alert = await this.alertController.create({
          cssClass: 'salir-login',
          header: '¡Salir de la aplicación!',
          message: '¿Estás seguro de que deseas salir de la aplicación?',
          buttons: [
            {
              text: 'Cancelar',
              id: 'cancel-button',
              //role: 'cancel',
              //cssClass: 'secondary',
              handler: (blah) => {
                //console.log('Confirm Cancel');
              }
            }, {
              text: 'Salir',
              id: 'confirm-button',
              cssClass: 'cerra-sesion',
              handler: () => {
                navigator['app'].exitApp();
              }
            }
          ],
          backdropDismiss: false
        });
      
        await alert.present();
      }else{
        this.navControlelr.back();
      }
    })
  }


  
}
